import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { DataQualityErrorMessage } from '../models/message-checker.model';
import { MessageCheckerEndpoint } from '../constants/message-checker-endpoint';

@Injectable({
  providedIn: 'root',
})
export class Sc4MessageCheckerService {
  constructor(private http: WrapperHttpService) {}

  checkSc4Message(payload: string): Observable<DataQualityErrorMessage> {
    const url = `${API_URL}${MessageCheckerEndpoint.Base}${MessageCheckerEndpoint.IFTSTA}${MessageCheckerEndpoint.SC4}${MessageCheckerEndpoint.Validate}`;
    return this.http.withLoading().post<DataQualityErrorMessage>(url, payload);
  }
}
